import { createReducer } from '@reduxjs/toolkit';

import { addUserOnline, removeUserOnline } from '../../thunks/users/userOnlineList';

const initialState = {
  users: [],
};

const userOnlineListReducer = createReducer(initialState, {
  [addUserOnline]: (state, { payload }) => ({
    ...state,
    users: [...state.users, payload],
  }),

  [removeUserOnline]: (state, { payload }) => ({
    ...state,
    users: state.users.filter((user) => user.id !== payload?.id),
  })
});

export default userOnlineListReducer;
